// Action Types
import {
  VIDFLEET_VIDEO_START_STREAMING,
  VIDFLEET_VIDEO_START_STREAMING_RESPONSE,
  VIDFLEET_VIDEO_STOP_STREAMING,
  VIDFLEET_VIDEO_STOP_STREAMING_RESPONSE,
  VIDFLEET_VIDEO_GET_STREAMING_STATUS,
  VIDFLEET_VIDEO_GET_STREAMING_STATUS_RESPONSE,
  VIDFLEET_VIDEO_GET_CLIP_BY_ID,
  VIDFLEET_VIDEO_GET_CLIP_BY_ID_RESPONSE,
  VIDFLEET_VIDEO_GET_PICTURE_BY_ID,
  VIDFLEET_VIDEO_GET_PICTURE_BY_ID_RESPONSE,
  VIDFLEET_VIDEO_GET_ONLINE_STATUS,
  VIDFLEET_VIDEO_GET_ONLINE_STATUS_RESPONSE,
  VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST,
  VIDFLEET_VIDEO_GET_CLIP_REQUEST_RESULT,
  VIDFLEET_VIDEO_MODAL_SHOW,
  VIDFLEET_VIDEO_MODAL_HIDE,
  CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
  loading: [],
  response: [],
  pictureResponse: [],
  loadingPicture: [],
  loadingCameraStatus: [],
  cameraStatusResponse: [],
  openModal: false,
  data: null,
  detail: false,
  clipRequest: null,
  loadingClipRequest: false,
  clipRequestId: null
};

export default (state = INIT_STATE, action) => {
  let ld = {};
  switch (action.type) {
    case VIDFLEET_VIDEO_START_STREAMING:
    case VIDFLEET_VIDEO_STOP_STREAMING:
    case VIDFLEET_VIDEO_GET_STREAMING_STATUS:
    case VIDFLEET_VIDEO_GET_CLIP_BY_ID:
      ld[action.payload.data] = true;
      return { ...state, payload: action.payload.data, loading: ld };

    case VIDFLEET_VIDEO_START_STREAMING_RESPONSE:
    case VIDFLEET_VIDEO_STOP_STREAMING_RESPONSE:
    case VIDFLEET_VIDEO_GET_STREAMING_STATUS_RESPONSE:
    case VIDFLEET_VIDEO_GET_CLIP_BY_ID_RESPONSE:
      ld[action.payload.data] = false;
      return { ...state, payload: {}, response: { ...state.response, ...action.payload.data }, loading: ld };

    case VIDFLEET_VIDEO_GET_PICTURE_BY_ID:
      ld[action.payload.data] = true;
      return { ...state, payload: action.payload.data, loadingPicture: ld };

    case VIDFLEET_VIDEO_GET_PICTURE_BY_ID_RESPONSE:
      ld[action.payload.data] = false;
      return { ...state, payload: {}, pictureResponse: { ...state.pictureResponse, ...action.payload.data }, loadingPicture: ld };

    case VIDFLEET_VIDEO_GET_ONLINE_STATUS:
      ld[action.payload.data] = true;
      return { ...state, payload: action.payload.data, loadingCameraStatus: ld };

    case VIDFLEET_VIDEO_GET_ONLINE_STATUS_RESPONSE:
      ld[action.payload.id] = false;
      return { ...state, payload: {}, cameraStatusResponse: { ...state.cameraStatusResponse, ...action.payload.data }, loadingCameraStatus: ld };

    case VIDFLEET_VIDEO_MODAL_SHOW:
      ld[action.payload.data] = true;
      return { ...state, openModal: true, data: action.payload.data, detail: action.payload.detail || false, clipRequestId: action.payload.clipRequestId };

    case VIDFLEET_VIDEO_MODAL_HIDE:
      ld[action.payload.data] = true;
      return { ...state, openModal: false };

    case VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST: {
      return { ...state, loadingClipRequest: true }
    }
    
    case VIDFLEET_VIDEO_GET_CLIP_REQUEST_RESULT:
      return { ...state, clipRequest: action.payload, loadingClipRequest: false }

    //clear redux video response
    case CLEAR_REDUX:
      return ["", "VIDFLEET_VIDEO"].includes(action.payload.option)
        ? action.payload.parameters
          ? { ...state, ...action.payload.parameters }
          : { ...INIT_STATE }
        : { ...state }

    default:
      return state;
  }
}
